(function () {
  if (window.FacettMtoLeadTime) return;

  function normalizeSize(value) {
    return String(value || '')
      .replace(/[＃#]/g, '')
      .replace(/[\s\u3000]/g, '')
      .replace(/[０-９]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
      })
      .replace(/号$/, '');
  }

  function parseData() {
    var node = document.getElementById('FacettMtoLeadTimeData');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function isQuickSize(sizeLabel, sizes, quickLead) {
    if (!quickLead || !sizes || !sizes.length) return false;
    var target = normalizeSize(sizeLabel);
    if (!target) return false;
    for (var i = 0; i < sizes.length; i += 1) {
      if (normalizeSize(sizes[i]) === target) return true;
    }
    return false;
  }

  function setText(nodes, text) {
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].textContent = text;
    }
  }

  function setHidden(nodes, hidden) {
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].hidden = hidden;
    }
  }

  function displaySize(label) {
    if (!data.hasSizeOption) return '';
    var size = String(label || '').trim();
    if (!size || size === 'Default Title' || size === data.productTitle) return '';
    return size;
  }

  function readVariantIdFromForm() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    var checked = form.querySelector('input[name="id"]:checked');
    if (checked) return checked.value;

    var select = form.querySelector('select[name="id"]');
    if (select) return select.value;

    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  var data = parseData();
  if (!data || !data.variants) return;

  window.FacettMtoLeadTime = true;

  function applyVariant(variantId) {
    var key = String(variantId || '');
    var variant = data.variants[key];
    if (!variant) return;

    var useQuick = !variant.available && isQuickSize(variant.sizeLabel, data.sizes, data.quickLead);
    var lead = useQuick ? data.quickLead : data.otherLead;
    var shipping = data.stockShipping;
    if (!variant.available) {
      shipping = useQuick ? data.quickShipping : data.otherShipping;
    }

    var notice = document.getElementById('product-made-to-order-notice');
    if (notice) notice.hidden = variant.available === true;

    var size = displaySize(variant.sizeLabel);
    setHidden(document.querySelectorAll('[data-mto-intro-size]'), !size);
    setHidden(document.querySelectorAll('[data-mto-intro-plain]'), !!size);
    setText(document.querySelectorAll('[data-mto-size-label]'), size);
    setText(document.querySelectorAll('[data-mto-lead-line]'), lead);

    var shippingNodes = document.querySelectorAll('[data-est-shipping-body]');
    for (var i = 0; i < shippingNodes.length; i += 1) {
      shippingNodes[i].textContent = shipping;
    }

    updatePriceBadge(variant.available === true);
  }

  function updatePriceBadge(available) {
    var badge = document.getElementById('product-pdp-status-badge');
    if (!badge) return;
    badge.hidden = available === true;
  }

  function handleVariantChange(variantId) {
    applyVariant(variantId);
  }

  document.addEventListener('change', function (event) {
    if (!event.target || event.target.name !== 'id') return;
    handleVariantChange(event.target.value);
  });

  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    handleVariantChange(event.detail.variant.id);
  });

  applyVariant(readVariantIdFromForm());
})();
